import React from "react";
import { PageHeader } from "../../../components";

export default function VICEPRESIDENT() {
  return (
    <div className="page-content">
      <PageHeader title="Management Details" page="management details" />
      {/* <!-- Content --> */}
      <div className="page-content">
        {/* <!-- Breadcrumb row END --> */}
        {/* <!-- contact --> */}
        <div className="content">
          {/* <!-- About Company --> */}
          <div className="section-fullbg-gray content-inner bg-gray ">
            <div className="container">
              <div className="row">
                <div className="col-md-5 col-sm-12 hidden-sm">
                  <img
                    src="./assets/images/members/LCC_VICE_PRESIDENT.jpeg"
                    alt=""
                    className="m-b30"
                    width="440"
                  />
                </div>
                <div className="col-md-7 col-sm-12">
                  <h3 className="h3">MR. ADETAYO ADEGBOYE</h3>
                  <div className="dlab-separator bg-primary"></div>
                  <h4 className="font-weight-3 00">
                   Adetayo Adegboye, MBA, ACIN.ACIB.

                   Mr. Adetayo is an associate of both the Chartered Insurance Institute of Nigeria and Chartered Insurance Brokers. He has over 30 years experience in the insurance industry.
                   He began his career with Yinka Omilani & Associate where he worked as a Marine Surveyor and Loss Adjuster for over fourteen years.

                   Mr. Adetayo joined Staco Insurance PLC in 2005 as the Controller Technical and rose to the post of Assistant Director, Head of Brokers Marketing & Energy. He left Staco in 2021 to join hands with seasoned professionals to promote the establishment
                   of Axton Insurance Brokers. He is currently the Managing Director / CEO of the thriving organization. In the course of his career, he has developed expertise in various classes of Insurance ranging from Special Risks, Including Oil and Energy as well as other General Business Policies.
                   An astute administrator with experience and core skills in Risk Management, Underwriting & Marketing, Efficient and Effective Claims Management and Strategy Development,
                   Mr Adetayo has attended several courses both locally and overseas.

                   At Club level, Mr Adetagyo Adegboye's contribution to the growth of Lagos Country Club cannot be over emphasized. He has served the club in various capacities prior to his election as Vice President.
                   He was at various times Secretary, Caretaker Committee, Chairman Electoral Committee, 2022 and 2023, Chairman, Aeorbics / Taekwondo 2021-2024, member Disciplinary committee 2020 as well as Entertainment Officer,
                   Aerobics / Taekwondo.
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- contact area  END --> */}
      </div>
    </div>
  );
}
